import React from 'react';
import FIPercBox from './fipercbox.js';

class FIUsersBreakDownTable extends React.Component {

	constructor(props) {
		super(props);

		window._fiSponsor.loadSessionInfo();
	}

	render() {

		if(!this.props.list || this.props.list.length === 0) return ('Data not found');
		const columnSize = Math.floor(this.props.list.length / 3) + 1;
		const size = (this.props.size) || { width:  '100%', height: 'auto' };
		const tooltipString = (window._fiSponsor.name !== 'West Community Credit Union' && window._fiSponsor.name !== 'Tigers Credit Union') ? "Where are your users banking?" : "Where are your users linked?"
		const cellSize = {
			width: '100%',
			height: '9vmin'
		};

		var fiCells = [];
		var fiColumn = [];

		for(var fiKey = 0; fiKey !== this.props.list.length; fiKey++) {
			var fiObj = this.props.list[fiKey];
			const logo = fiObj.logo.length ? fiObj.logo : 'Unknown';

			var cell = (
				<FIPercBox key={fiKey} size={cellSize} perc={fiObj.percentage} logo={logo} bank_label={fiObj.bank_label} rtn={fiObj.routing} />
			);

			fiColumn.push(cell);

			if((fiKey - columnSize * fiCells.length) === columnSize - 1 || fiKey === this.props.list.length - 1) {
				fiCells.push((
					<div key={fiKey + '-Col'} className='FIUsersBreakDownTable-Column' style={{width: cellSize.width}}>
						{fiColumn}
					</div>
				));

				fiColumn = [];
			}
		}

		return (
			<div className="FIUsersBreakDownTable" style={{width: size.width, maxWidth: '100%', height: size.height}}>
				<div className="FIUsersBreakDownTable-Header">{tooltipString}</div>
				<div className="FIUsersBreakDownTable-Row" style={{width: size.width, maxWidth: '100%', height: size.height}}>
					{fiCells}
				</div>
			</div>
		);
	}
}

export default FIUsersBreakDownTable;